import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurantleftsidebar',
  templateUrl: './restaurantleftsidebar.component.html',
  styleUrls: ['./restaurantleftsidebar.component.css']
})
export class RestaurantleftsidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
